import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: var(--space-3xl);
  text-align: center;
`;

const BlogPost = () => {
  return (
    <Container>
      <h1>Blog Post</h1>
      <p>Individual blog post content will be displayed here.</p>
    </Container>
  );
};

export default BlogPost;
